import {
  GET_LIST_BANHANGTRAGOP,
  GET_LIST_BANHANGTRAGOP_SUCCESS,
  GET_LIST_BANHANGTRAGOP_FAILURE,
} from "./actionTypes";

export const getListBanHangTraGop = (dataSearch) => ({
  type: GET_LIST_BANHANGTRAGOP,
  dataSearch,
});

export const getListBanHangTraGopSuccess = (data) => ({
  type: GET_LIST_BANHANGTRAGOP_SUCCESS,
  payload: data,
});

export const getListBanHangTraGopFailure = () => ({
  type: GET_LIST_BANHANGTRAGOP_FAILURE,
});
